import React, { useState } from 'react';

const Gavetas = () => {
  const [gavetaAberta, setGavetaAberta] = useState(1); // Começa com a primeira aberta

  const handleGavetaClick = (numeroGaveta) => {
    setGavetaAberta(numeroGaveta); // Sempre abre a gaveta clicada e fecha as outras
  };

  const gavetas = [
    { numero: 1, titulo: 'QUEM PODE EMITIR A CARTEIRA DE ESTUDANTE?', conteudo: 'O parágrafo segundo do artigo 1º da Lei Federal 12.933/13 sob os efeitos supressivos de medida cautelar da ADI 5108 do STF (Supremo Tribunal Federal), dá autonomia a qualquer entidade estudantil para a emissão de Carteiras de Estudante, sejam elas, diretórios ou centros acadêmicos, entidades municipais, estaduais ou nacionais, desde que sigam o PADRÃO NACIONAL e as especificações técnicas do ITI (Instituto Nacional de Tecnologia da Informação) para certificação de atributos.' },
    { numero: 2, titulo: 'ONDE POSSO USAR MINHA CARTEIRA?', conteudo: 'A carteira de estudante UNISC ESTUDANTIL deve ser usada somente para eventos culturais e esportivos, não podendo ser usada em transporte publico.' },
    { numero: 3, titulo: 'QUAL A VALIDADE DA CARTEIRA?', conteudo: 'A lei da meia entrada estabelece (Art. 1º paragrafo 6º) que a carteira de Identificação Estudantil (CIE) será válida da data de sua expedição até o dia 31 de março do ano subsequente' },
    { numero: 4, titulo: 'A UNISC TEM APLICATIVO?', conteudo: 'Não, a carteira UNISC Estudantil fica disponível somente através do site (https://www.uniscestudantil.org.br), não havendo outra maneira de consultar ou fazer download da carteira.' },
    { numero: 5, titulo: 'COMO FUNCIONA A CARTEIRA DIGITAL?', conteudo: `O download da carteira digital pode ser feito através do nosso site (https://www.uniscestudantil.org.br/), consulte sua carteira na seção 'VERIFIQUE SUA CARTEIRA' preenchendo o campo de consulta com CPF ou Código de uso.` },
  ];

  return (
    <div className="flex flex-col bg-[#7ED957] w-full max-w-[100%] px-4 py-6 rounded-2xl border border-black lg:max-w-[60%] lg:w-2/3">
      {gavetas.map(({ numero, titulo, conteudo }) => (
        <div
          key={numero}
          className="rounded-md mb-4 overflow-hidden bg-[#ffffff]"
          onClick={() => handleGavetaClick(numero)}
        >
          <h3 className="p-3 font-bold text-center cursor-pointer text-sm font-roboto-condensed lg:text-base">{titulo}</h3>
          <div 
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              gavetaAberta === numero 
                ? 'max-h-96 opacity-100 p-4 lg:p-6' 
                : 'max-h-0 opacity-0 p-0'
            }`}
          >
            <p className="text-sm text-left font-roboto-condensed lg:text-md">{conteudo}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Gavetas;
